import React, { useContext } from 'react';
import { Container } from 'reactstrap';
import styles from './DTCHeader.module.css';
import { ReactComponent as Phone } from '../../../assets/images/Phone_Icon.svg';
import { ReactComponent as AIG } from '../../../assets/images/aig-logo.svg';
import { BuildPlanContext } from '../../contexts/DTC/DTCContext';
import CategoryStepIcon from './CategoryStepIcon';
import cn from 'classnames';

const DTCHeader = () => {
    const { state, dispatch } = useContext(BuildPlanContext);

    const handlePreviousClick = () => {
        dispatch({
            type: 'TRAVERSE_STEPS',
            payload: { direction: 'previous' }
        });

        // MIGHT NEED ROUTING LOGIC HERE IF IT DOESN'T WORK IN REDUCER.
        // IF SO, PULL IT OUT TO A HELPER IN UTIL.
    };

    const { currentStep, steps } = state;
    const categorySteps = steps.filter((s) => s.type === 'shopCategory');
    return (
        <Container>
            <header>
                <div className={styles.phoneHeader}>
                    <Phone className={styles.phoneIcon} />
                    XXX-XXX-XXXX
                </div>
                <div className={styles.mainHeader}>
                    <h1 className='h3'>{'{PROGRAM NAME}'}</h1>
                    <AIG className={styles.aigLogo} />
                </div>
                {/* ADD SOME SORT OF CONDITION TO SHOW/HIDE THIS */}
                {!state.buildingCustomPlan ? (
                    <nav className={styles.categoryNav}>
                        <ul>
                            <li>Appliances</li>
                            <li>Electrical</li>
                            <li>Heat & Air</li>
                            <li>Utilities</li>
                            <li>Plumbing</li>
                        </ul>
                    </nav>
                ) : (
                    <nav>
                        <nav className={styles.buildPlanNav}>
                            <button
                                onClick={handlePreviousClick}
                                className={styles.previousStep}
                            >
                                {'< Previous'}
                            </button>
                            {currentStep?.type === 'shopCategory' ? (
                                <>
                                    <h2 className={cn('h3')}>{currentStep.category.name} Plans</h2>
                                    <div className={cn('ml-auto', styles.flex)}>
                                        {categorySteps.map((cS, i, arr) => (
                                            <>
                                                <CategoryStepIcon
                                                    category={cS.category}
                                                    active={cS.category.id === currentStep.category.id}
                                                />
                                                {i !== arr.length - 1 && (
                                                    <>
                                                        <div className={styles.dividerDot} />
                                                        <div className={styles.dividerDot} />
                                                    </>
                                                )}
                                            </>
                                        ))}
                                    </div>
                                </>
                            ) : (
                                <h2 className='h5 ml-auto'>Let's build a plan just right for you.</h2>
                            )}
                        </nav>
                    </nav>
                )}
            </header>
        </Container>
    );
};

export default DTCHeader;
